'use strict';

/* ================================================================
   NEEN — JS del tema (idéntico al landing original, con guardas
   para que también funcione en producto / colección / carrito)
   ================================================================ */

// ===== PLAN DATA =====
var PLANS = {
  mensual: {
    name: 'Plan Mensual', price: 'USD 39,99',
    period: 'por mes · cobro cada 30 días',
    benefit: '✦ Ideal para probar sin comprometerte de más',
    heroDetail: 'Acceso completo por 30 días para empezar sin pensarlo tanto. Cobro recurrente cada 30 días.'
  },
  '4x3': {
    name: 'Plan 4×3', price: 'USD 119,97',
    period: '4 meses · pagás solo 3 · cobro cada 120 días',
    benefit: '🏆 Es el plan más elegido · Ahorrás USD 40',
    heroDetail: 'Pagás 3 meses y entrenás 4. <strong>Ahorrás USD 40.</strong> Cobro recurrente cada 120 días.'
  },
  anual: {
    name: 'Plan Anual', price: 'USD 239,59',
    period: 'por año completo · cobro anual',
    benefit: '💰 El mejor precio · Ahorrás USD 240',
    heroDetail: 'Doce meses de acceso completo. <strong>Ahorrás USD 240</strong> frente al plan mensual. Cobro recurrente anual.'
  }
};

var ALT_BENEFITS = {
  mensual: 'Opción flexible, sin compromiso largo',
  '4x3':   '🏆 Ahorrás USD 40 · El más elegido',
  anual:   '💰 Ahorrás USD 240 · El mejor precio'
};

var currentHeroPlan = '4x3';
var currentPlanId   = '4x3';

// ===== SMOOTH SCROLL HELPER =====
function scrollToId(id) {
  var el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    // No estamos en el home: volvemos al home y saltamos al ancla
    window.location.href = (window.NEEN_HOME_URL || '/') + '#' + id;
  }
}

// ===== NAVBAR SCROLL STATE =====
(function () {
  var navbar = document.getElementById('navbar');
  if (!navbar) return;
  window.addEventListener('scroll', function () {
    navbar.classList.toggle('scrolled', window.scrollY > 12);
  }, { passive: true });
})();

// ===== HAMBURGER / MOBILE MENU =====
(function () {
  var hamburger  = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobileMenu');
  if (!hamburger || !mobileMenu) return;

  function closeMobileMenu() {
    mobileMenu.classList.remove('open');
    hamburger.classList.remove('active');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  function openMobileMenu() {
    mobileMenu.classList.add('open');
    hamburger.classList.add('active');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  hamburger.addEventListener('click', function () {
    mobileMenu.classList.contains('open') ? closeMobileMenu() : openMobileMenu();
  });
  document.querySelectorAll('.mlink').forEach(function (a) {
    a.addEventListener('click', closeMobileMenu);
  });
})();

// ===== HERO PLAN SELECTOR =====
(function () {
  var wrap = document.getElementById('heroPlanTabs');
  if (!wrap) return;
  var heroTabs = wrap.querySelectorAll('.hero-plan-tab');
  heroTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      heroTabs.forEach(function (t) { t.classList.remove('selected'); });
      tab.classList.add('selected');
      currentHeroPlan = tab.dataset.plan;
      var detail = document.getElementById('heroPlanDetail');
      if (detail) detail.innerHTML = '<p>' + PLANS[currentHeroPlan].heroDetail + '</p>';
    });
  });
})();

// ===== MODAL =====
function renderAltPlans() {
  var container = document.getElementById('modalAltPlans');
  if (!container) return;
  container.innerHTML = '';
  Object.keys(PLANS).forEach(function (id) {
    if (id === currentPlanId) return;
    var p = PLANS[id];
    var div = document.createElement('div');
    div.className = 'modal-alt-plan';
    div.setAttribute('role', 'button');
    div.setAttribute('tabindex', '0');
    div.innerHTML =
      '<div><div class="name">' + p.name + '</div>' +
      '<div class="benefit">' + ALT_BENEFITS[id] + '</div></div>' +
      '<div class="price-sm">' + p.price + '</div>';
    div.addEventListener('click', function () { openModal(id); });
    div.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') openModal(id);
    });
    container.appendChild(div);
  });
}

function openModal(planId) {
  currentPlanId = planId || '4x3';
  var overlay = document.getElementById('modalOverlay');

  // Fuera del home no hay modal: vamos directo al checkout del plan
  if (!overlay) { neenGoCheckout(); return; }

  var plan = PLANS[currentPlanId];
  var set = function (id, value) {
    var el = document.getElementById(id);
    if (el) el.textContent = value;
  };
  set('modalTitle', 'Elegiste ' + plan.name);
  set('modalPlanName', plan.name);
  set('modalPlanPrice', plan.price);
  set('modalPlanPeriod', plan.period);
  set('modalBenefitLine', plan.benefit);

  renderAltPlans();
  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeModal() {
  var overlay = document.getElementById('modalOverlay');
  if (!overlay) return;
  overlay.classList.remove('open');
  document.body.style.overflow = '';
}

// ===== CHECKOUT DEL PLAN SELECCIONADO =====
// Las URLs se configuran en Personalizar tema → Configuración → NEEN · Planes y checkout
function neenGoCheckout() {
  var urls = window.NEEN_PLAN_URLS || {};
  var url  = urls[currentPlanId];
  if (url && url !== '' && url !== '#') {
    window.location.href = url;
  } else {
    window.location.href = (window.NEEN_FALLBACK_URL || '/collections/suplementos');
  }
}

(function () {
  var overlay = document.getElementById('modalOverlay');
  if (!overlay) return;
  overlay.addEventListener('click', function (e) {
    if (e.target.id === 'modalOverlay') closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();

// ===== FAQ ACCORDION =====
document.querySelectorAll('.faq-q').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var item   = btn.closest('.faq-item');
    var answer = item.querySelector('.faq-a');
    var isOpen = item.classList.contains('open');

    document.querySelectorAll('.faq-item').forEach(function (i) {
      i.classList.remove('open');
      i.querySelector('.faq-a').style.maxHeight = '0';
    });

    if (!isOpen) {
      item.classList.add('open');
      answer.style.maxHeight = answer.scrollHeight + 44 + 'px';
    }
  });
});

// ===== REVEAL ON SCROLL =====
(function setupReveal() {
  var isEmbedded = window.self !== window.top;
  var els = document.querySelectorAll('.rv');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (isEmbedded || reduceMotion || !window.IntersectionObserver) {
    els.forEach(function (el) { el.classList.add('in'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('in');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

  els.forEach(function (el) {
    if (!el.classList.contains('in')) observer.observe(el);
  });

  setTimeout(function () { els.forEach(function (el) { el.classList.add('in'); }); }, 2200);
})();

// ===== CANTIDADES DEL CARRITO =====
document.querySelectorAll('[data-qty-btn]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var step = btn.dataset.qtyBtn === 'up' ? 1 : -1;
    var min  = parseInt(input.min || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    var form = btn.closest('form');
    if (form && form.dataset.autosubmit === 'true') form.submit();
  });
});

/* ================================================================
   CARRUSELES DE TESTIMONIOS
   - Movimiento continuo por CSS; acá solo el control de los videos.
   - Autoplay silenciado, se reproducen solo cuando están a la vista.
   - Un botón por tarjeta activa el sonido; al activarlo se pausa el
     carrusel y se silencian los demás videos.
   ================================================================ */
(function () {
  var cards = document.querySelectorAll('.nv-card');
  if (!cards.length) return;

  var videos = [];
  cards.forEach(function (card) {
    var video = card.querySelector('video');
    if (!video) return;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.removeAttribute('controls');
    videos.push(video);
  });
  if (!videos.length) return;

  // Reproducir solo lo que está en pantalla
  if (window.IntersectionObserver) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else {
          video.pause();
          if (!video.muted) silence(video);
        }
      });
    }, { threshold: 0.25 });
    videos.forEach(function (v) { observer.observe(v); });
  } else {
    videos.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); });
  }

  function silence(video) {
    var card = video.closest('.nv-card');
    video.muted = true;
    if (card) {
      card.classList.remove('is-live');
      var btn = card.querySelector('[data-sound]');
      if (btn) {
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', 'Activar sonido');
      }
      var marquee = card.closest('[data-marquee]');
      if (marquee && !marquee.querySelector('.nv-card.is-live')) marquee.classList.remove('is-paused');
    }
  }

  function toggleSound(video) {
    if (!video) return;
    if (video.muted) {
      videos.forEach(function (other) { if (other !== video && !other.muted) silence(other); });
      video.muted = false;
      video.volume = 1;
      var card = video.closest('.nv-card');
      if (card) {
        card.classList.add('is-live');
        var btn = card.querySelector('[data-sound]');
        if (btn) {
          btn.setAttribute('aria-pressed', 'true');
          btn.setAttribute('aria-label', 'Silenciar');
        }
        var marquee = card.closest('[data-marquee]');
        if (marquee) marquee.classList.add('is-paused');
      }
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    } else {
      silence(video);
    }
  }

  cards.forEach(function (card) {
    var video = card.querySelector('video');
    if (!video) return;
    var btn = card.querySelector('[data-sound]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleSound(video);
      });
    }
    video.addEventListener('click', function () { toggleSound(video); });
  });

  // Al salir de la pestaña, silenciar todo
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) videos.forEach(function (v) { if (!v.muted) silence(v); });
  });
})();

/* ================================================================
   FICHA DE PRODUCTO: galería, cantidad y selector de sabor
   ================================================================ */
(function () {
  var track = document.querySelector('[data-gal-track]');
  if (track) {
    var slides = track.children.length;
    var index = 0;
    var dots = document.querySelectorAll('[data-gal-dots] i');
    var thumbs = document.querySelectorAll('[data-gal-thumbs] button');

    var go = function (n) {
      index = (n + slides) % slides;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('on', k === index); });
      thumbs.forEach(function (t, k) { t.classList.toggle('on', k === index); });
    };

    var prev = document.querySelector('[data-gal="prev"]');
    var next = document.querySelector('[data-gal="next"]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.dataset.i, 10)); });
    });

    var startX = null;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45) go(dx < 0 ? index + 1 : index - 1);
      startX = null;
    });
  }

  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      if (!input) return;
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10));
    });
  });

  var pills = document.querySelector('[data-variant-pills]');
  if (pills) {
    var hidden = document.querySelector('[data-variant-input]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var stickyEl = document.querySelector('[data-sticky-price]');
    pills.querySelectorAll('.buy-opt:not(.off)').forEach(function (opt) {
      opt.addEventListener('click', function () {
        pills.querySelectorAll('.buy-opt').forEach(function (o) { o.classList.remove('on'); });
        opt.classList.add('on');
        if (hidden) hidden.value = opt.dataset.variant;
        if (priceEl) priceEl.textContent = opt.dataset.price;
        if (stickyEl) stickyEl.textContent = opt.dataset.price;
        if (compareEl) compareEl.textContent = opt.dataset.compare;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', opt.dataset.variant);
        window.history.replaceState({}, '', url);
      });
    });
  }
})();

/* ================================================================
   CARRITO: datos de factura electrónica
   Los campos solo aparecen si la persona marca la casilla, y se
   envían como atributos del pedido.
   ================================================================ */
(function () {
  var box = document.querySelector('[data-invoice]');
  if (!box) return;

  var toggle = box.querySelector('[data-invoice-toggle]');
  var fields = box.querySelector('[data-invoice-fields]');
  var requeridos = box.querySelectorAll('[data-invoice-required]');
  if (!toggle || !fields) return;

  function sync() {
    var on = toggle.checked;
    fields.hidden = !on;
    box.classList.toggle('is-open', on);
    requeridos.forEach(function (input) {
      if (on) { input.setAttribute('required', 'required'); }
      else { input.removeAttribute('required'); input.setCustomValidity(''); }
    });
  }

  toggle.addEventListener('change', sync);
  sync();

  // Si pide factura, no dejamos pasar al checkout con los campos vacíos
  var form = box.closest('form');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!toggle.checked) return;
      var faltante = null;
      requeridos.forEach(function (input) {
        if (!faltante && !input.value.trim()) faltante = input;
      });
      if (faltante) {
        e.preventDefault();
        faltante.focus();
        faltante.reportValidity();
      }
    });
  }
})();

/* ================================================================
   PROMOCIONES: popup de lanzamiento y copia del código
   ================================================================ */
(function () {
  // --- Copiar el código de descuento (popup y ficha de producto) ---
  document.querySelectorAll('[data-promo-code]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var code = btn.dataset.promoCode || '';
      var aviso = function () {
        var label = btn.querySelector('[data-promo-copy-label]');
        if (label) {
          var antes = label.textContent;
          label.textContent = '¡Copiado!';
          setTimeout(function () { label.textContent = antes; }, 2200);
        } else {
          var original = btn.textContent;
          btn.classList.add('copiado');
          btn.textContent = '¡Copiado!';
          setTimeout(function () { btn.textContent = original; btn.classList.remove('copiado'); }, 2200);
        }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(aviso).catch(function () {});
      } else {
        var tmp = document.createElement('input');
        tmp.value = code;
        document.body.appendChild(tmp);
        tmp.select();
        try { document.execCommand('copy'); aviso(); } catch (e) {}
        document.body.removeChild(tmp);
      }
    });
  });

  // --- Popup ---
  var overlay = document.querySelector('[data-promo]');
  if (!overlay) return;

  var key = overlay.dataset.key || 'neen-promo';
  var preview = overlay.dataset.preview === 'true';
  var delay = parseInt(overlay.dataset.delay, 10) || 0;

  var yaCerrado = false;
  if (!preview) {
    try { yaCerrado = window.localStorage.getItem(key) === 'cerrado'; } catch (e) { yaCerrado = false; }
  }
  if (yaCerrado) return;

  function abrir() {
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function cerrar() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    if (!preview) {
      try { window.localStorage.setItem(key, 'cerrado'); } catch (e) {}
    }
  }

  setTimeout(abrir, preview ? 400 : delay);

  overlay.querySelectorAll('[data-promo-close]').forEach(function (b) {
    b.addEventListener('click', cerrar);
  });
  overlay.addEventListener('click', function (e) { if (e.target === overlay) cerrar(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('open')) cerrar();
  });
  var cta = overlay.querySelector('.promo-cta');
  if (cta) cta.addEventListener('click', cerrar);
})();
